module.exports = __webpack_public_path__ + "static/media/default_tutorial_2.04271cd0.jpg";